





  import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'Content',
})
export default class Content extends Vue {}
